import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { breakpointDown } from '../../../../services/responsive/responsive';
import useBodyClass from '../../../../hooks/useBodyClass';
import useContentSidenav from './hooks/useContentSidenav';
import AngleRightIcon from '../../../../components/icons/AngleRightIcon';
import Button from '../../../../components/global/Button';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  wrapperClassname: PropTypes.string,
};

const ContentSideNav = ({ children, className, wrapperClassname }) => {
  const { sideNavExpanded, onSideNavCollapse } = useContentSidenav();

  const mobile = useMediaQuery(breakpointDown('sm'));
  const classes = classNames({
    'pro-wrapper-content-sidenav': true,
    'pro-wrapper-content-sidenav-expanded': sideNavExpanded,
    [className]: !!className,
  });
  const wrapperClasses = classNames({
    'pro-wrapper-content-sidenav-wrap': true,
    [wrapperClassname]: !!wrapperClassname,
  });

  useBodyClass('body-mobile-pro-panels-open', sideNavExpanded);

  // Always collapse the side nav when unmounting.
  useEffect(() => {
    if (!mobile) {
      // Safeguard against changing layouts on Desktop
      onSideNavCollapse();
      document.body.classList.remove('body-mobile-pro-panels-open');
    }

    return () => {
      if (mobile) {
        onSideNavCollapse();
        document.body.classList.remove('body-mobile-pro-panels-open');
      }
    };
  }, [mobile]);

  return (
    <div className={classes}>
      <div id="pm-sidebar-wrapper" className={wrapperClasses}>
        {mobile && (
          <div className="d-flex w-100">
            <Button
              btnStyle="link"
              onClick={onSideNavCollapse}
              className="ml-auto text-bold mb-3"
            >
              Hide
              <AngleRightIcon className="ml-2" width={9} color="#0d84fe" />{' '}
            </Button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

ContentSideNav.propTypes = propTypes;

export default ContentSideNav;
